/**
 * en-GB messages for the Phase 3 contract (architect): module names, permissions, triggers, webhook events, merge
 * fields and shared message keys. Builders add their own screen text in their task's file.
 */
export const archEnGB = {
    // Modules
    'module.occupancy': 'Live occupancy',
    'module.nfc-cards': 'NFC cards',
    // Permission groups and permissions
    'permGroup.contactless': 'Contactless sign-in',
    'permGroup.sign_in_points': 'Sign-in points',
    'permGroup.occupancy': 'Occupancy',
    'permGroup.nfc_cards': 'NFC cards',
    'perm.evacuation.start': 'Start and end evacuations and drills',
    'perm.evacuation.mark': 'Mark people safe or missing',
    'perm.evacuation.manage': 'Manage muster points, fire panels and evacuation settings',
    'perm.contactless.manage': 'Manage contactless sign-in',
    'perm.sign_in_points.manage': 'Manage sign-in points',
    'perm.lone_working.manage': 'Manage lone-working contacts and settings',
    'perm.permits.manage_types': 'Manage permit types',
    'perm.occupancy.view': 'View occupancy',
    'perm.occupancy.manage': 'Manage site capacity',
    'perm.nfc_cards.view': 'View NFC cards',
    'perm.nfc_cards.manage': 'Register and block NFC cards',
    // Notification triggers (labels; default texts come with each owner's task file)
    'notify.trigger.compliance.check_failed': 'Compliance check failed',
    'notify.trigger.evacuation.started': 'Evacuation started',
    'notify.trigger.evacuation.ended': 'Evacuation ended',
    'notify.trigger.permit.open_at_sign_out': 'Signed out with a permit open',
    'notify.trigger.permit.expired': 'Permit passed its end time',
    'notify.trigger.lone_working.escalated': 'Lone worker missed a check-in',
    'notify.trigger.lone_working.panic': 'Lone worker pressed the panic button',
    'notify.trigger.delivery.arrived': 'Delivery arrived',
    'notify.trigger.occupancy.capacity_reached': 'Capacity reached',
    'notify.trigger.nfc.blocked_card_used': 'Blocked NFC card used',
    // Webhook events
    'whk.event.evacuation.started': 'Evacuation started',
    'whk.event.evacuation.ended': 'Evacuation ended',
    'whk.event.safety_check.failed': 'Safety check failed',
    'whk.event.delivery.logged': 'Delivery logged',
    'whk.event.delivery.collected': 'Delivery collected',
    'whk.event.permit.issued': 'Permit issued',
    'whk.event.permit.closed': 'Permit closed',
    'whk.event.lone_working.escalated': 'Lone-worker escalation',
    'whk.event.occupancy.level_changed': 'Occupancy level changed',
    // Merge fields
    'merge.evacuation.kind': 'Evacuation or drill',
    'merge.evacuation.started_at': 'Evacuation start time',
    'merge.evacuation.point': 'Muster point',
    'merge.evacuation.directions': 'Muster point directions',
    'merge.evacuation.counts': 'Roll-call counts',
    'merge.permit.number': 'Permit number',
    'merge.permit.type': 'Permit type',
    'merge.permit.area': 'Permit area',
    'merge.permit.holder': 'Permit holder',
    'merge.permit.ends_at': 'Permit end time',
    'merge.lone.person': 'Lone worker',
    'merge.lone.site': 'Lone worker site',
    'merge.lone.last_check_in': 'Last check-in',
    'merge.lone.location_link': 'Location link (panic only)',
    'merge.delivery.carrier': 'Carrier',
    'merge.delivery.parcels': 'Number of parcels',
    'merge.delivery.location': 'Where to collect',
    'merge.occupancy.count': 'People on site',
    'merge.occupancy.capacity': 'Site capacity',
    'merge.occupancy.level': 'Occupancy level',
    'merge.compliance.document': 'Document',
    'merge.compliance.expiry_date': 'Expiry date',
    'merge.compliance.days_left': 'Days left',
    // Shared message keys used across Phase 3 modules (ADR 0026 and others)
    'error.sign_in_refused': 'This sign-in was refused. Please see reception.',
    'error.evacuation_active': 'An evacuation is in progress at this site.',
    'error.nfc_card_in_use': 'This card is already registered to someone else.',
    'error.permit_open': 'This visit has an open permit to work.',
    'check.safety_check.refused': 'Please see reception before signing in.',
    'check.safety_check.alert': 'Allowed in with an alert to reception (safety check).',
    'check.compliance.refused': 'A required document is missing or has expired. Please see reception.',
    'check.compliance.warned': 'A required document is missing or has expired.',
    'check.induction.required': 'Please complete the site induction first.',
    'check.capacity.full': 'The site is full at the moment. Please see reception.',
    'check.capacity.warned': 'Signed in while the site was over capacity.',
    'check.offline': 'Recorded while the kiosk was offline.',
    'nfc.card_blocked': 'This card has been blocked. Please see reception.',
};
//# sourceMappingURL=arch.js.map